import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkObject'
})
export class CheckObjectPipe implements PipeTransform {
  transform(value: any): string {
    return typeof value === 'object' && value !== null ? '' : value;
  }
}